module.exports = __webpack_public_path__ + "img/square-small.0032b083.svg";